import { Components, Theme } from '../../material';

export const MuiLink: Components<Theme>['MuiLink'] = {
  defaultProps: {
    color: 'inherit',
  },
  styleOverrides: {
    root: {
      textDecorationColor: 'inherit',
    },
  },
};
